import React from "react";
//#region types
import { EntityNavigationCardContainerProps } from "models/propTypes/navigationPropTypes";
import { ServiceConstants } from "utils/constants";
//#endregion
//#region components
import useMountedState from "../useMountedState";
//#endregion

const EntityNavigationCardContainer: React.FC<EntityNavigationCardContainerProps> = (props) => {
  const { render, numPerPage } = props;

  const { getMounted } = useMountedState();
  const [loading, setIsLoading] = React.useState(false);
  const [items, setItems] = React.useState<any[]>([]);
  const [currentItem, setCurrentItem] = React.useState<any>();
  const [total, setTotal] = React.useState<number>(0);
  const [currentPage, setCurrentPage] = React.useState<number>(0);

  React.useEffect(() => {
    reloadItems(0, 0);
  }, []);

  const reloadItems = async (index: number, pageNumber: number) => {
    setIsLoading(true);
    const data = await props
      .filter({ ...ServiceConstants.DefaultFilter, page: pageNumber, numPerPage: numPerPage })
      .then((res) => res.data);
    if (getMounted()) {
      const currentItems = data.items ?? [];
      setItems(currentItems);
      setTotal(data.totalItems);
      setCurrentItem(currentItems[index]);
      setIsLoading(false);
    }
  };

  const updateCurrent = (index: number, page: number) => {
    if (items[index] === undefined || currentPage !== page) {
      reloadItems(index, page);
      setCurrentPage(page);
    } else {
      setCurrentItem(items[index]);
    }
  };

  const removeCurrentItem = (id: number) => {
    const toRemoveIndex = items.findIndex((item) => item.id === id);
    const updatedItems = [...items];
    updatedItems.splice(toRemoveIndex, 1);

    if (getMounted()) {
      setCurrentItem(updatedItems[toRemoveIndex]);
      setItems(updatedItems);
      setTotal(total - 1);
    }
  };

  return render(total, numPerPage, updateCurrent, removeCurrentItem, currentItem, loading);
};

export default EntityNavigationCardContainer;
